/**
 * 缓存说明:历史示值缓存
 */
import vm from './storeTools.js'
import historyApi from '../components/api/historyApi.js'

var basestate = {
	deviceNos:'',
	beginTime: new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24,
	endTime: new Date(new Date().toLocaleDateString()).getTime(),
	historyShowValues:[]
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		setdeviceNos(state, data) {
			vm.Vue.set(state, 'deviceNos', data)
			if(isempty(data)){
				return
			}
			store.commit('searchHistoryIndicationValue')
		},
		setbeginTime(state, data) {
			vm.Vue.set(state, 'beginTime', data)
		},
		setendTime(state, data) {
			vm.Vue.set(state, 'endTime', data)
		},
		searchHistoryIndicationValue(state, unitId){
			historyApi.searchHistoryIndicationValue(state.deviceNos,state.beginTime,state.endTime, respon => {
				vm.Vue.set(state, 'historyShowValues', respon)
				for(var i=0; i< Object.values(state.historyShowValues).length;i++){
					if (isNaN(parseFloat(Object.values(state.historyShowValues)[i].beginValue)) || isnull(parseFloat(Object.values(state.historyShowValues)[i].beginValue))) {
						Object.values(state.historyShowValues)[i].beginValue = '- -'
					}
					if (isNaN(parseFloat(Object.values(state.historyShowValues)[i].endValue)) || isnull(parseFloat(Object.values(state.historyShowValues)[i].endValue))) {
						Object.values(state.historyShowValues)[i].endValue = '- -'
					}
					if (isNaN(parseFloat(Object.values(state.historyShowValues)[i].value)) || isnull(parseFloat(Object.values(state.historyShowValues)[i].value))) {
						Object.values(state.historyShowValues)[i].value = 0
					}
					if (isNaN(parseFloat(Object.values(state.historyShowValues)[i].coefficient)) || isnull(parseFloat(Object.values(state.historyShowValues)[i].coefficient))) {
						Object.values(state.historyShowValues)[i].coefficient = '- -'
					}
				}
			},respon => {
				this.$message({
					message: respon,
					type: 'error'
				});
			})
		},
	}
});

//对外提供
export default store
